import familiadosApiClient from '$utils/familiadosApiClient'
import { apiRouter } from '$domain/model/apiRouter'
import { apiErrorService } from '$utils/services/apiErrorService'
import { mapToSelectedCaretakersDetails } from '$domain/model/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.mapper'
import { SelectedCaretakerDetailsDto } from '$domain/model/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.model'

export const getSelectedCaretakersDetails = async (caretakersId: string[]) => {
  try {
    const detailsOfSelectedCaretakers = await familiadosApiClient.get<SelectedCaretakerDetailsDto[]>(
      apiRouter.getSelectedCaretakerDetailsPath(),
      { caretakerId: caretakersId },
    )
    return mapToSelectedCaretakersDetails(detailsOfSelectedCaretakers)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/selectedCaretakersDetails/selectedCaretakersDetails.manager.ts